// extracted by mini-css-extract-plugin
module.exports = {"nav":"Overview_nav__3Ijus","item":"Overview_item__3KxAn"};